import { render, staticRenderFns } from "./pending-doctor-details.vue?vue&type=template&id=619cd894&"
import script from "./pending-doctor-details.vue?vue&type=script&lang=js&"
export * from "./pending-doctor-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports